import { refreshToken } from 'utils/push-notifications';
import { useMutation, useQueryClient } from 'react-query';
import useUploadStore from 'store/uploads/useUploadStore';
import { useUpdateDeviceTokenMutation } from './useUpdateDeviceTokenMutation';
import { defaultMutationFn } from 'api/useAPI';
import { Authentication } from 'models';
import { saveCredentials } from 'api/lib/localStorageManagement';

export function useLoginMutation() {
  const client = useQueryClient();
  const uploadStoreData = useUploadStore((uploadStore) => ({
    initialize: uploadStore.initialize,
    closeUppyInstances: uploadStore.closeUppyInstances,
  }));
  const { mutateAsync: updateDeviceToken } = useUpdateDeviceTokenMutation();
  return useMutation(
    async ({
      emailAddress,
      password,
    }: {
      emailAddress: string;
      password: string;
    }) => {
      // just for testing will remove after testing is completed.
      const authenticationStrategy =
        localStorage.getItem('authenticationStrategy') || 'V2';
      const user: Authentication = await defaultMutationFn(
        '/authenticate',
        'POST',
        {
          password,
          username: emailAddress,
          authenticationStrategy,
        }
      );
      if (user) {
        saveCredentials({
          authBearerToken: user.token,
          authBearerTokenExpiration: user.expirationDate,
          authRefreshToken: user.refreshToken,
        });
        client.setQueryData('/authenticate/token', user, {
          updatedAt: Date.now(),
        });
      }
      uploadStoreData.closeUppyInstances();
      uploadStoreData.initialize();
      refreshToken(updateDeviceToken);
    }
  );
}
